(() => {
  const root = document.querySelector('[data-product]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('[data-variant-data]').textContent);
  const hero = root.querySelector('[data-product-image]');
  const select = (id, updateHistory) => {
    const v = data.variants.find(v => String(v.id) === String(id));
    if (!v) return;
    const price=root.querySelector('[data-product-price]'); if(price) price.textContent = v.price;
    root.querySelector('[data-product-sku]').textContent = v.sku;
    root.querySelector('[data-color-name]').textContent = v.title;
    root.querySelectorAll('[data-variant-link]').forEach(a => {
      if (a.dataset.variantLink === String(v.id)) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
    if (v.image && hero) { hero.removeAttribute('srcset'); hero.src = v.image; hero.alt = root.querySelector('h1').textContent + ' — ' + v.title; }
    const purchase=root.querySelector('[data-purchase-variant]'); if(purchase){purchase.value=v.id; purchase.form.querySelector('[name=add]').disabled=!v.available;}
    if (updateHistory) {
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.pushState(null, '', url);
    }
  };
  root.querySelectorAll('[data-variant-link]').forEach(a => a.addEventListener('click', e => { if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); select(a.dataset.variantLink, true); }));
  root.querySelectorAll('[data-gallery-image]').forEach(a => a.addEventListener('click', e => { if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || !hero) return; e.preventDefault(); hero.removeAttribute('srcset'); hero.src = a.dataset.galleryImage; hero.alt = a.querySelector('img').alt; }));
  window.addEventListener('popstate', () => select(new URL(location.href).searchParams.get('variant') || data.variants[0].id, false));
})();

(() => {
    const hero = document.querySelector("[data-product-image]");
      const thumbs = document.querySelectorAll("[data-gallery-image]");
        if (!hero || !thumbs.length) return;
          const sync = () => thumbs.forEach(a => {
                if (new URL(a.dataset.galleryImage, location.href).href === hero.src) a.setAttribute("aria-current", "true");
                    else a.removeAttribute("aria-current");
                      });
                        new MutationObserver(sync).observe(hero, { attributes: true, attributeFilter: ["src"] });
                          sync();
                    })();

          